import {
  ClickAwayListener,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useState } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import TextLink from '../../text-link';
import Tooltip from '../../tooltip';

const useTooltipStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 260,
      height: 'auto',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      padding: '1em',
    },
  }),
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeIcon: {
      position: 'absolute',
      top: '4px',
      right: '-10px',
    },
  }),
);

type Props = {
  tabIndex?: number;
  showCloseIcon?: boolean;
};

const PaymentLimitsFees = ({ tabIndex, showCloseIcon }: Props) => {
  const { t, richT } = useTranslation();
  const tooltipClasses = useTooltipStyles();
  const classes = useStyles();
  const [isOpen, toggleOpen] = useState(false);

  const isPGEPlusRoute = window.location.pathname.includes('/pge-plus');

  return (
    <ClickAwayListener onClickAway={() => toggleOpen(false)}>
      <Tooltip
        open={isOpen}
        classes={tooltipClasses}
        onClose={() => toggleOpen(false)}
        title={
          <>
            {showCloseIcon ? (
              <IconButton
                className={classes.closeIcon}
                onClick={() => toggleOpen(false)}
              >
                <Close />
              </IconButton>
            ) : null}
            <Typography component={'div'}>
              {isPGEPlusRoute
                ? richT('PGE_PLUS_POP_PAYMENT_LIMIT_AND_FEE_CONTENT')
                : richT('PAYMENT_LIMIT_AND_FEE_CONTENT')}
            </Typography>
          </>
        }
        placement={'bottom-start'}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <span>
          <TextLink
            tabIndex={tabIndex}
            onClick={e => {
              e.preventDefault();
              toggleOpen(!isOpen);
            }}
            external
            tooltip
          >
            {t('PAYMENT_LIMIT_AND_FEE')}
          </TextLink>
        </span>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default PaymentLimitsFees;
